// extracted by mini-css-extract-plugin
export default {"value":"LegendNumberValue_value__iz+Bf"};